import { Trophy } from "lucide-react"

interface StreakIndicatorProps {
  streak: number
  multiplier: number
}

export function StreakIndicator({ streak, multiplier }: StreakIndicatorProps) {
  return (
    <div className="flex items-center gap-2 text-sm bg-gradient-to-r from-primary/5 to-transparent
                  px-4 py-2 rounded-full border border-primary/10">
      <Trophy className={`h-4 w-4 ${streak > 0 ? 'text-yellow-400 animate-pulse' : 'text-muted-foreground'}`} />
      <span className="font-medium tracking-wide">
        Streak: {streak}
      </span>
      {multiplier > 1 && (
        <span className="text-primary font-bold bg-primary/10 px-2 rounded-full animate-pulse">
          ({multiplier}x)
        </span>
      )}
    </div>
  )
}